<template>
  <div class="not-yet-implemented-view">
    <h1 class="page-title-container">Hoppala!</h1>
    <p>Diese Seite existiert (noch) nicht...</p>
  </div>
</template>

<script>
export default {
  name: "NotYetImplementedView",
};
</script>

<style lang="scss" scoped>
.not-yet-implemented-view {
  p {
    padding: 10px;
  }
}
</style>
